import { render, staticRenderFns } from "./UserResponsiveCard.vue?vue&type=template&id=3a30a95a&scoped=true"
import script from "./UserResponsiveCard.vue?vue&type=script&lang=js"
export * from "./UserResponsiveCard.vue?vue&type=script&lang=js"
import style0 from "./UserResponsiveCard.vue?vue&type=style&index=0&id=3a30a95a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a30a95a",
  null
  
)

export default component.exports